/**
 * Return a promise which will be resolved after the given timeout.
 * Can be used in a sync. way. ecample: `await Sleep(1500)`
 */
export default function Sleep(ms: number) {
    return new Promise<void>((resolve) => {
        setTimeout(() => resolve(), ms)
    })
}
